




























































































































































































































































































































































































































































































































































































































































































































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import MemberListingTable from '@front-app/views/csr/communityReports/MemberListingTable.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import RadioList from '@front-app/components/inputs/RadioList.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import UserGroupDetailsTable from '@front-app/views/csr/communityReports/UserGroupDetailsTable.vue';
import {
	AllMemberListingReportRequest,
	DEFAULT_REPORT_OPTION,
	fetchAllMemberListingReport,
	NetworkSearchUser,
	REPORT_FILTER_TYPE,
	REPORT_ROLE_FILTER_OPTION,
	REPORT_TYPE,
} from '@front-app/services/CommunityApi/CommunityReportsApi';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { Size, Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useRadioButtons } from '@front-app/hooks/useRadioButtons';
import { ALL_USER_ROLE_LABELS, USER_ACCOUNT_STATUSES,	USER_ACCOUNT_STATUS_LABELS } from '@front-app/services/UserApi/UserModel';
import { UserProfileOptionsStore } from '@front-app/store/singletons/UserProfileOptions';

enum GroupMemberListingSortOrder {
	FIRST_NAME = 'FIRST_NAME',
	LAST_NAME = 'LAST_NAME',
	ROLE = 'ROLE',
	ORGANIZATION = 'ORGANIZATION',
	ACCOUNT_STATUS = 'ACCOUNT_STATUS',
}

const SORT_CHOICES = [
	GroupMemberListingSortOrder.FIRST_NAME,
	GroupMemberListingSortOrder.LAST_NAME,
	GroupMemberListingSortOrder.ROLE,
	GroupMemberListingSortOrder.ORGANIZATION,
	GroupMemberListingSortOrder.ACCOUNT_STATUS,
];

const SORT_TYPE_LABELS: Record<GroupMemberListingSortOrder, string> = {
	[GroupMemberListingSortOrder.FIRST_NAME]: 'user-profile.first-name',
	[GroupMemberListingSortOrder.LAST_NAME]: 'user-profile.last-name',
	[GroupMemberListingSortOrder.ROLE]: 'csr.community-queries.role',
	[GroupMemberListingSortOrder.ORGANIZATION]: 'user-profile.professional-information.organization.header',
	[GroupMemberListingSortOrder.ACCOUNT_STATUS]: 'csr.community-queries.account-status',
};

export default defineComponent({
	components: {
		ButtonList,
		ChevronIcon,
		CtaButton,
		ErrorCard,
		FormInput,
		MemberListingTable,
		PublicLink,
		RadioList,
		SimpleDropdown,
		TrCheckbox,
		TrForm,
		UserGroupDetailsTable,
	},
	props: {
		reportType: {
			type: String as PropType<REPORT_TYPE>,
			required: true,
		},
	},
	setup(props, ctx) {
		const reportData: Ref<NetworkSearchUser[]> = ref([]);
		const reportStatus = useAsyncStatus();

		const fetchingProfileOptionsStatus = useAsyncStatus();
		onMounted(() => {
			fetchingProfileOptionsStatus.track(UserProfileOptionsStore.fetch());
		});
		const allSpecialties = computed(() => UserProfileOptionsStore.specialties.value.sort((a, b) => {
			if (a.name > b.name) {
				return 1;
			}
			if (a.name < b.name) {
				return -1;
			}
			return 0;
		}));
		const allInterests = computed(() => UserProfileOptionsStore.interests.value);
		const allAccountStatuses = computed(() => USER_ACCOUNT_STATUSES
			.map((status) => ({
				key: status,
				label: ctx.root.$t(USER_ACCOUNT_STATUS_LABELS[status]) as unknown as string,
			})));

		// Email search
		const userSearchEmail = ref('');

		// Filters
		const isAvatarFilterMenuOpen = ref(false);
		const isRoleFilterMenuOpen = ref(false);
		const isOrganizationFilterMenuOpen = ref(false);
		const isSpecialtyFilterMenuOpen = ref(false);
		const isInterestsFilterMenuOpen = ref(false);
		const isVerificationFilterMenuOpen = ref(false);
		const isLanguageFilterMenuOpen = ref(false);

		const hasAvatar = ref(DEFAULT_REPORT_OPTION.NO_SELECTION as unknown as boolean | DEFAULT_REPORT_OPTION);
		const roles = ref([] as string[]);
		const hasAnyRole = ref(false);
		const hasNoRoles = ref(false);
		const hasOrganization = ref(DEFAULT_REPORT_OPTION.NO_SELECTION as unknown as boolean | DEFAULT_REPORT_OPTION);
		const specialtyIds = ref([] as number[]);
		const hasAnySpecialty = ref(false);
		const hasNoSpecialties = ref(false);
		const interestIds = ref([] as number[]);
		const hasAnyInterest = ref(false);
		const hasNoInterests = ref(false);
		const accountStatuses = ref([] as string[]);
		const primaryLanguage = ref(DEFAULT_REPORT_OPTION.NO_SELECTION as unknown as string | DEFAULT_REPORT_OPTION);

		const applyFilter = (type: REPORT_FILTER_TYPE, setting: string | boolean | DEFAULT_REPORT_OPTION | REPORT_ROLE_FILTER_OPTION) => {
			switch (type) {
			case REPORT_FILTER_TYPE.AVATAR:
				if (typeof setting !== 'string' || setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					hasAvatar.value = setting;
				}
				break;
			case REPORT_FILTER_TYPE.ROLE:
				if (setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					roles.value = [];
					hasAnyRole.value = false;
					hasNoRoles.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.ANY) {
					roles.value = [];
					hasAnyRole.value = true;
					hasNoRoles.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.NONE) {
					roles.value = [];
					hasAnyRole.value = false;
					hasNoRoles.value = true;
				} else if (typeof setting === 'string' && roles.value.includes(setting)) {
					roles.value = roles.value.filter((role) => role !== setting);
					hasNoRoles.value = false;
					hasAnyRole.value = false;
				} else if (typeof setting === 'string') {
					roles.value.push(setting);
					hasNoRoles.value = false;
					hasAnyRole.value = false;
				}
				break;
			case REPORT_FILTER_TYPE.ORGANIZATION:
				if (typeof setting !== 'string' || setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					hasOrganization.value = setting;
				}
				break;
			case REPORT_FILTER_TYPE.SPECIALTY:
				if (setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					specialtyIds.value = [];
					hasAnySpecialty.value = false;
					hasNoSpecialties.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.ANY) {
					specialtyIds.value = [];
					hasAnySpecialty.value = true;
					hasNoSpecialties.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.NONE) {
					specialtyIds.value = [];
					hasAnySpecialty.value = false;
					hasNoSpecialties.value = true;
				} else if (typeof setting === 'number' && specialtyIds.value.includes(setting)) {
					specialtyIds.value = specialtyIds.value.filter((id) => id !== setting);
					hasAnySpecialty.value = false;
					hasNoSpecialties.value = false;
				} else if (typeof setting === 'number') {
					specialtyIds.value.push(setting);
					hasAnySpecialty.value = false;
					hasNoSpecialties.value = false;
				}
				break;
			case REPORT_FILTER_TYPE.INTERESTS:
				if (setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					interestIds.value = [];
					hasAnyInterest.value = false;
					hasNoInterests.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.ANY) {
					interestIds.value = [];
					hasAnyInterest.value = true;
					hasNoInterests.value = false;
				} else if (setting === DEFAULT_REPORT_OPTION.NONE) {
					interestIds.value = [];
					hasAnyInterest.value = false;
					hasNoInterests.value = true;
				} else if (typeof setting === 'number' && interestIds.value.includes(setting)) {
					interestIds.value = interestIds.value.filter((id) => id !== setting);
					hasAnyInterest.value = false;
					hasNoInterests.value = false;
				} else if (typeof setting === 'number') {
					interestIds.value.push(setting);
					hasAnyInterest.value = false;
					hasNoInterests.value = false;
				}
				break;
			case REPORT_FILTER_TYPE.VERIFICATION:
				if (setting === DEFAULT_REPORT_OPTION.NO_SELECTION) {
					accountStatuses.value = [];
				} else if (typeof setting === 'string' && accountStatuses.value.includes(setting)) {
					accountStatuses.value = accountStatuses.value.filter((status) => status !== setting);
				} else if (typeof setting === 'string') {
					accountStatuses.value.push(setting);
				}
				break;
			case REPORT_FILTER_TYPE.LANGUAGE:
				if (typeof setting !== 'boolean') {
					primaryLanguage.value = setting;
				}
				break;
			default:
				throw new Error(`Unable to set the ${type} Network User Search filter to ${setting}`);
			}
		};

		const resetFilters = () => {
			userSearchEmail.value = '';
			hasAvatar.value = DEFAULT_REPORT_OPTION.NO_SELECTION;
			roles.value = [];
			hasAnyRole.value = false;
			hasNoRoles.value = false;
			hasOrganization.value = DEFAULT_REPORT_OPTION.NO_SELECTION;
			specialtyIds.value = [];
			hasAnySpecialty.value = false;
			hasNoSpecialties.value = false;
			interestIds.value = [];
			hasAnyInterest.value = false;
			hasNoInterests.value = false;
			accountStatuses.value = [];
			primaryLanguage.value = DEFAULT_REPORT_OPTION.NO_SELECTION;
		};

		// Sort
		const {
			choices: sortChoices,
			selectedChoice: selectedSort,
			select: selectSort,
		} = useRadioButtons(ctx, {
			choiceKeys: ref(SORT_CHOICES),
			labels: SORT_TYPE_LABELS,
			initialChoice: GroupMemberListingSortOrder.FIRST_NAME,
		});

		const sortResults = (sort: GroupMemberListingSortOrder) => {
			reportData.value = reportData.value.sort((a, b) => {
				switch (sort) {
				case GroupMemberListingSortOrder.FIRST_NAME:
					return a.firstName.localeCompare(b.firstName);
				case GroupMemberListingSortOrder.LAST_NAME:
					return a.lastName.localeCompare(b.lastName);
				case GroupMemberListingSortOrder.ROLE:
					if (a.roles.length > 0 && b.roles.length > 0) {
						// Sort by the first role alphabetically
						return (ctx.root.$t(ALL_USER_ROLE_LABELS[a.roles[0]]) as string).localeCompare(ctx.root.$t(ALL_USER_ROLE_LABELS[b.roles[0]]) as string);
					}
					if (a.roles.length > 0 && b.roles.length === 0) {
						return -1;
					}
					if (a.roles.length === 0 && b.roles.length > 0) {
						return 1;
					}
					return 0;
				case GroupMemberListingSortOrder.ORGANIZATION:
					if (a.organizationName && b.organizationName) {
						return a.organizationName.localeCompare(b.organizationName);
					}
					if (a.organizationName && !b.organizationName) {
						return -1;
					}
					if (!a.organizationName && b.organizationName) {
						return 1;
					}
					return 0;
				case GroupMemberListingSortOrder.ACCOUNT_STATUS:
					return a.accountStatus.localeCompare(b.accountStatus);
				default:
					// eslint-disable-next-line
					const exhaustiveCheck: never = sort;
					throw new Error(`Unhandled sort case: ${exhaustiveCheck}`);
				}
			});
			selectSort(sort);
		};

		// Member management
		const isMemberManagementEnabled = ref(false);
		const isActionsDropdownOpen = ref(false);
		const selectedUserIds = ref([] as string[]);
		const areAllUsersSelected = ref(false);
		const toggleAllUserIds = () => {
			if (areAllUsersSelected.value) {
				selectedUserIds.value = [];
				areAllUsersSelected.value = false;
			} else {
				reportData.value.forEach((user) => {
					if (!selectedUserIds.value.includes(user.id)) {
						selectedUserIds.value = selectedUserIds.value.concat(user.id);
					}
				});
				areAllUsersSelected.value = true;
			}
		};
		const toggleUserId = (id: string) => {
			if (selectedUserIds.value.includes(id)) {
				selectedUserIds.value = selectedUserIds.value.filter((userId) => userId !== id);
				if (areAllUsersSelected.value) {
					areAllUsersSelected.value = false;
				}
			} else {
				selectedUserIds.value = selectedUserIds.value.concat(id);
				let areAllUserIdsSelected = true;
				// eslint-disable-next-line
				for (let user of reportData.value) {
					if (!selectedUserIds.value.includes(user.id)) {
						areAllUserIdsSelected = false;
						break;
					}
				}
				areAllUsersSelected.value = areAllUserIdsSelected;
			}
		};

		// Run report
		const runReport = async () => {
			const payload: AllMemberListingReportRequest = {
				email: userSearchEmail.value,
				hasAvatar: typeof hasAvatar.value === 'boolean' ? hasAvatar.value : null,
				roles: (hasAnyRole.value || hasNoRoles.value) ? [] : roles.value,
				hasAnyRole: hasAnyRole.value,
				hasNoRoles: hasNoRoles.value,
				hasOrganization: typeof hasOrganization.value === 'boolean' ? hasOrganization.value : null,
				specialtyIds: (hasAnySpecialty.value || hasNoSpecialties.value) ? [] : specialtyIds.value,
				hasAnySpecialty: hasAnySpecialty.value,
				hasNoSpecialties: hasNoSpecialties.value,
				interestIds: (hasAnyInterest.value || hasNoInterests.value) ? [] : interestIds.value,
				hasAnyInterest: hasAnyInterest.value,
				hasNoInterests: hasNoInterests.value,
				accountStatuses: accountStatuses.value.length > 0 ? accountStatuses.value : [],
				primaryLanguage: primaryLanguage.value === DEFAULT_REPORT_OPTION.NO_SELECTION ? null : primaryLanguage.value,
			};
			reportData.value = await reportStatus.track(fetchAllMemberListingReport(payload));
			sortResults(GroupMemberListingSortOrder.FIRST_NAME);
			selectedUserIds.value = [];
			areAllUsersSelected.value = false;
		};

		return {
			userSearchEmail,
			hasAvatar,
			roles,
			hasAnyRole,
			hasNoRoles,
			hasOrganization,
			specialtyIds,
			hasAnySpecialty,
			hasNoSpecialties,
			interestIds,
			hasAnyInterest,
			hasNoInterests,
			allAccountStatuses,
			accountStatuses,
			primaryLanguage,
			// Filters
			allSpecialties,
			allInterests,
			REPORT_FILTER_TYPE,
			REPORT_ROLE_FILTER_OPTION,
			DEFAULT_REPORT_OPTION,
			isAvatarFilterMenuOpen,
			isRoleFilterMenuOpen,
			isOrganizationFilterMenuOpen,
			isSpecialtyFilterMenuOpen,
			isInterestsFilterMenuOpen,
			isVerificationFilterMenuOpen,
			isLanguageFilterMenuOpen,
			applyFilter,
			resetFilters,
			// Sort
			sortChoices,
			selectedSort,
			sortResults,
			SORT_TYPE_LABELS,
			// Member management
			isMemberManagementEnabled,
			isActionsDropdownOpen,
			selectedUserIds,
			areAllUsersSelected,
			toggleAllUserIds,
			toggleUserId,
			// Report data
			runReport,
			reportStatus,
			reportData,
			// Util
			ButtonPalettes,
			DropdownPosition,
			Size,
			Spacing,
		};
	},
});
